import http from '@/utils/http'
import Utils from '@/utils/default'

const fetchAll = filter => http()
  .get(`/activities?${Utils.dataToUrlString(filter)}`)

export default {
  fetchAll
}



// WEBPACK FOOTER //
// ./src/api/activity.js